<template>
  <div>
    <v-icon color="amber accent-4" @click="mostrarModal=true">mdi-pencil</v-icon>
      <v-dialog v-model="mostrarModal" transition="dialog-bottom-transition" fullscreen>
      <v-card>
        <!-- TOOLBAR -->
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="mostrarModal=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Pedido</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items> <v-btn
              dark
              text
              @click="mostrarModal=false"
            >
              Salir
            </v-btn> </v-toolbar-items>
        </v-toolbar>
        <!-- TERMINA TOOLBAR -->

        <!-- NÚMERO DE PEDIDO Y BOTÓN EDITAR -->
        <div class="d-flex justify-space-between mt-3">
          <div class="d-flex">
            <span class="text-h5 mx-3">Pedido {{infoPedido.FOLIO}}.</span>
            <v-btn class="mx-3 red darken-1" dark small text @click="editar = !editar">
              Editar.
            </v-btn>
          </div>
        </div>
        <!-- TERMINA NÚMERO DE PEDIDO Y BOTÓN EDITAR -->

        <v-card class="ma-3 allB" :disabled="!editar">
          <v-row style="margin: 0px !important">
            <v-col cols="12" sm="12" md="12">
              <v-card-text>
                <!-- INFORMACIÓN DEL FOLIO -->
                <v-col cols="12" sm="12" md="12" class="d-flex">
                  <v-text-field
                    label="Folio"
                    v-model="infoPedido.FOLIO"
                    filled
                    dense
                    prepend-icon="mdi-information-variant"
                    :disabled="true"
                  />
                  <!-- <v-text-field
                    v-if="pedidos && pedidos != 'N/A'"
                    label="Pedido"
                    v-model="pedidos"
                    filled
                    dense
                    prepend-icon="mdi-information-variant"
                    :disabled="true"
                  /> -->
                </v-col>
                <!-- TERMINA INFORMACIÓN DEL FOLIO -->
                <div>
                  <!-- SECCIÓN FECHA -->
                  <v-menu
                    v-model="modalFecha"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    :disabled="editar"
                  >                  
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechaSeleccionada"
                        label="Fecha a entregar"
                        prepend-icon="mdi-calendar"
                        filled
                        light
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fechaSeleccionada"
                      @input="modalFecha = false"
                      :min="minFecha[0]"
                    >
                    </v-date-picker>
                  </v-menu>
                  <!-- FIN SECCIÓN FECHA -->

                  <!-- DESCRIPCIÓN -->
                  <v-textarea 
                    v-model="descripcion"
                    label="Descripcion"
                    maxlength="50" 
                    outlined
                    counter
                  />
                  <!-- TERMINA DESCRIPCIÓN -->

                  <!-- INFORMACIÓN ARTICULOS DEL PEDIDO -->
                  <div class="allB ma-1 pa-1">

                    <v-card-title>Articulos Pedidos</v-card-title>
                    <!-- BARRA DE BÚSQUEDA -->
                    <div class="d-flex">
                      <v-text-field
                        v-model="buscador"
                        label="Buscar"
                        append-icon="mdi-magnify"
                        class="mx-1"
                        single-line
                        hide-details
                      />
                      <v-spacer></v-spacer>
                    </div>
                    <!-- TERMINA BARRA DE BÚSQUEDA -->

                    <!-- TABLA CON ARTÍCULOS -->
                    <v-data-table
                    v-model="articuloSeleccionado"
                    :items="articulos"
                    :headers="columnasArticulos"
                    :search="buscador"
                    :disable-filtering="editar"
                    :disable-sort="editar"
                    :items-per-page="5"
                    :show-select="dividirArt"
                    item-key="ARTICULO_ID"
                    class="text-caption text-justify"
                    id="tabla"
                    >
                    <!-- TERMINA TABLA CON ARTÍCULOS -->
                    
                    <template v-slot:[`header.data-table-select`]></template>
                    <template v-slot:[`item.AccionSeparar`] = "{ item }">
                      <div v-if="ajustarItem(item)">
                        <v-text-field
                          v-model="item.CANTIDADRESTA"
                          label="Cantidad"
                          type="number"
                          min="1"
                          :max="item.CANTIDADMAXIMA"
                        />
                      </div>
                      <div v-else>
                        Selecciona
                      </div>
                    </template>

                    <template v-slot:[`item.AccionQuitar`]="{ item }">
                      <v-btn
                      @click="EliminarArticuloReq(item)"
                      small
                      text
                      dark
                      class="red darken-1"
                      >
                        Eliminar
                      </v-btn>
                    </template>

                    </v-data-table>
                  </div>
                </div>
                <div class="d-flex justify-center">
                  <v-btn
                  class="success darken-1"
                  small
                  text
                  v-if="mostrarArticulos != true && dividirArt==false"
                  @click="mostrarArticulos = true"
                  >
                    Agregar Articulos
                  </v-btn>
                </div>
                </v-card-text>
                <v-divider></v-divider>
                <!-- </div> -->
            </v-col>
            <!-- PRIMERA TABLA ARTICULOS -->
            <v-col cols="12" sm="12" md="6" v-if="mostrarArticulos" class="">
              <div class="d-flex">
                <v-card-title>Agregar Articulos</v-card-title>
                <v-btn
                  class="red lighten-2 mt-5 mx-3"
                  dark
                  text
                  small
                  v-if="(mostrarArticulos = true)"
                  @click="mostrarArticulos = false"
                  >Cerrar
                </v-btn>
              </div>
              <v-text-field
                v-model="buscador"
                append-icon="mdi-magnify"
                label="Buscar clave"
                single-line
                hide-details
              />
              <v-data-table
                class="pa-0"
                :items="articulos"
                :headers="columnas"
                :search="buscador"
                :loading="cargandoArt"
                :disable-filtering="editar"
                :disable-sort="editar"
                :items-per-page="5"
                item-key="ARTICULO_ID"
              >
                <template v-slot:[`item.AccionAgregar`]="{ item }">
                  <v-btn
                    @click="AgregarArticulo(item)"
                    small
                    light
                    class="amber lighten-2"
                    style=""
                  >
                    Agregar
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
            <!-- FIN PRIMERA TABLA ARTICULOS -->
            <v-divider
              vertical
              style="border-color: rgba(0, 0, 0, 0.42)"
            ></v-divider>
            <!-- SEGUNDA TABLA ARTICULOS -->
            <v-col cols="12" sm="12" md="6" v-if="mostrarArticulos">
              <v-card-title>Articulos En Requisicion</v-card-title>
              <v-text-field
                v-model="buscador2"
                append-icon="mdi-magnify"
                label="Buscar clave"
                single-line
                hide-details
              />
              <v-data-table
                class="pa-0"
                :items="articulosAgregados"
                :headers="columnas2"
                :search="buscador2"
                :loading="cargando"
                :disable-filtering="editar"
                :disable-sort="editar"
                :items-per-page="5"
                item-key="ARTICULO_ID"
              >
                <template v-slot:[`item.AccionCantidad`]="{ item }">
                  <v-text-field
                    v-model="item.CANTIDAD"
                    label="Cantidad"
                    type="number"
                    min="1"
                  />
                </template>
                <template v-slot:[`item.AccionObservaciones`]="{ item }">
                  <v-textarea
                    v-model="item.OBSERVACIONES"
                    label="Observaciones"

                  />
                </template>
                <template v-slot:[`item.AccionQuitar`]="{ item }">
                  <v-btn
                  @click="QuitarArticulo(item)"
                  small
                  text
                  dark
                  class="red darken-1"
                  >
                    Quitar
                  </v-btn>
                </template>
                <template slot="no-data">
                  <v-alert class="my-1" :value="true" type="info" color="orange darken-2" >
                    Los articulos agregados se mostrarán aquí.
                  </v-alert>
                </template>
              </v-data-table>
            </v-col>
            <!-- FIN SEGUNDA TABLA ARTICULOS -->
          </v-row>
          <!-- {{articulos}} -->
        </v-card>
        <v-btn color="black" dark @click="log">Mostrar</v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {

  props:['infoPedido'],

  data() {
    return {
      mostrarModal:     false,
      buscador: "",
      editar:           false,
      fechaSeleccionada:'',
      modalFecha:       false,
      minFecha:         "",
      descripcion:      "",
      articuloSeleccionado: [],
      articulos:[],

      columnasArticulos: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        //{ text: "Almacen",   valie: "ALMACEN"},
        { text: "Articulo", value: "NOMBRE", filterable:false },
        { text: "Cantidad", value: "CANTIDAD"},
        { text: "Agregar", sortable: false, value: "actionEditar", align: "right",},
      ],
    }
  },

  computed: {
    ...mapGetters(['getURLAPI','getFechaActual'])
  },

  methods: {
    async getDetalle(){
      this.articulos = (await axios.get(
        `${this.getURLAPI}/Pedidos/mostrarPedidosDetalles/${this.infoPedido.PEDIDO_ID}`
        )).data
      console.log(this.articulos);
    },

    log(){
      console.log(this.infoPedido);
    }
  },

  created() {
    this.minFecha = this.getFechaActual.split(" ");
    this.fechaSeleccionada = this.infoPedido.FECHA.split(" ")[0]
    this.descripcion = this.infoPedido.DESCRIPCION;
    this.getDetalle();
    console.log(this.infoPedido);
  },

}
</script>

<style>

</style>